import EditCertificationPopup from './EditCertificationPopup';

export default EditCertificationPopup;
